import { render, staticRenderFns } from "./MainHeaderChannel.vue?vue&type=template&id=73b018a9&scoped=true&lang=pug&"
import script from "./MainHeaderChannel.vue?vue&type=script&lang=js&"
export * from "./MainHeaderChannel.vue?vue&type=script&lang=js&"
import style0 from "./MainHeaderChannel.vue?vue&type=style&index=0&id=73b018a9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b018a9",
  null
  
)

export default component.exports